import React from 'react';

const PackingPrint = () => {
    return (
        <span>Printing Page</span>
    );
};

export default PackingPrint;
